import React, { useEffect, useState } from 'react';
import { Link,  useNavigate } from 'react-router-dom';
import { postLogin } from '../../Servicios/Servicios';
import { useSpinner } from '../../Component/spinner/spinner';
import bg from "../../assets/image/background.jpeg";
import background from "../../assets/image/loginBackgroundContenedor.png";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("Bar");
  const navigate = useNavigate();
  const spinner = useSpinner();
  
  useEffect( () => {
    
    // Verificar si ya hay un token de acceso
    const accessToken = localStorage.getItem("access");
    const refreshToken = localStorage.getItem("refresh");
    if (accessToken || refreshToken) {
      // Si hay un token, redirigir a la página de eventos
      navigate("/Eventos");
    }
  }, [ navigate ]);

  const Ingresar = async () => {
    // Aquí puedes agregar la lógica de inicio de sesión
    spinner.show();
    
    try {
      // Aquí podrías validar los campos antes de enviar la solicitud
      if (!username || !password) {
        alert("Por favor, completa todos los campos.");
        spinner.hide();
        return;
      }
      const response = await postLogin(username, password);
      
      if (response.access && response.refresh) {

        localStorage.setItem("access", response.access);
        localStorage.setItem("refresh", response.refresh);
        navigate("/Eventos")
        spinner.hide();
      }else{
        alert("Error al iniciar sesión. Por favor, verifica tus credenciales.");
        spinner.hide();
      }

    } catch (error) {
      spinner.hide();
      console.error("Error al validar los campos:", error); 
    }

  }; 
  
  return (
    <div className="min-h-screen flex items-center justify-center" style={{
            backgroundImage: `url(${bg})`,
            position:'absolute', height: '100%', width:'100%'
          }}>
      <div className="  max-w-5xl rounded-lg overflow-hidden shadow-lg flex" style={{backgroundImage:`url(${background})`, backgroundRepeat: 'no-repeat'}}>
        {/* Izquierda */}
        <div className="w-full p-8">

          <h2 className="text-xl font-semibold text-gray-800 mb-6 text-center text-white">
            Inicia Sesion
          </h2>


          {/* Toggle */}
          <div className="flex gap-2 mb-4">
            <button
              onClick={() => setType("Bar")}
              className={`flex-1 py-2 rounded ${type === "Bar" ? "bg-[#4F60A8] text-white" : "bg-gray-200 text-gray-700"}`}
            >
              Bar
            </button>
            <button
              onClick={() => setType("Restaurant")}
              className={`flex-1 py-2 rounded ${type === "Restaurant" ? "bg-[#4F60A8] text-white" : "bg-gray-200 text-gray-700"}`}
            >
              Restaurante
            </button>
          </div>

          <p className="text-sm text-gray-500 mb-4 text-white">
            Iniciarás sesión como un establecimiento tipo {type}.
          </p>

          {/* Inputs */}
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            type="email"
            placeholder="Correo electrónico"
            className="w-full mb-3 px-4 py-2 border rounded bg-gray-100 focus:outline-none"
          />
          <input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            placeholder="Contraseña"
            className="w-full mb-4 px-4 py-2 border rounded bg-gray-100 focus:outline-none"
          />

          <button onClick={()=>Ingresar()} type="submit" className="w-full bg-[#4F60A8] text-white py-2 rounded hover:bg-[#4F60A8]-100 mb-6">
            Iniciar sesión
          </button>
          <p className="text-sm text-gray-500 text-center mt-1">
            <Link to={"/RestablecerCon"} className="text-blue-600 underline">
              Restablecer Contraseña?{' '}
            </Link>
            {/* <a href="#" className="text-blue-600 underline">Regístrate aquí</a> */}
          </p>

          {/* Botones sociales */}
          {/*<p className="text-center text-gray-400 text-sm mb-4">También puedes</p>

           <button className="w-full flex items-center justify-center gap-2 border border-blue-500 text-blue-600 py-2 rounded mb-3">
            <img src="https://img.icons8.com/color/16/000000/google-logo.png" alt="Google" />
            Iniciar sesión con Google
          </button>
          <button className="w-full flex items-center justify-center gap-2 border border-blue-500 text-blue-600 py-2 rounded">
            <img src="https://img.icons8.com/color/16/000000/facebook-new.png" alt="Facebook" />
            Iniciar sesión con Facebook
          </button> */}

          <p className="text-sm text-gray-500 text-center mt-6">
            <Link to={"/Registrar"} className="text-blue-600 underline">
              ¿No tienes cuenta?{' '}
            </Link>
            {/* <a href="#" className="text-blue-600 underline">Regístrate aquí</a> */}
          </p>
        </div>

        {/* Derecha */}
        {/* <div
          className="hidden md:flex w-1/2 items-center justify-center bg-cover bg-center relative"
          style={{
            backgroundImage: `url('/img/Logo_Login.png')`, // Reemplaza con tu imagen
          }}
        >
          <div className="absolute bottom-8 right-8 text-white text-right">
            <p className="text-lg font-light">Tu establecimiento</p>
            <p className="text-md font-thin">En la Palma de la Mano</p>
          </div>
        </div> */}
      </div>
    </div>
  );
}
